/**
 * EAN form web component.
 * Manages EAN/requisition number inputs, localStorage, and cart attribute injection.
 */
class EanForm extends HTMLElement {
  constructor() {
    super();
    this._boundHandlers = {};
  }

  connectedCallback() {
    const eanInputs = this.querySelectorAll(".ean--input");
    const eanTrigger = this.querySelector("[data-ean-trigger]");
    const eanInput = this.querySelector("#ean");
    const requisitionNumberInput = this.querySelector("#requisitionNumber");
    const cartForm = document.querySelector('#cart-form');

    if (!eanInput || !requisitionNumberInput || !cartForm) return;

    this._eanInput = eanInput;
    this._requisitionNumberInput = requisitionNumberInput;
    this._cartForm = cartForm;
    this._eanInputs = eanInputs;
    this._eanTrigger = eanTrigger;

    if (this.hasAttribute("ean-open")) {
      eanInputs.forEach((input) => input.setAttribute("required", "true"));
    }

    this._boundHandlers.selfClick = () => {
      if (!this.hasAttribute("ean-open")) {
        this.setAttribute("ean-open", "true");
      }
      eanInputs.forEach((input) => input.setAttribute("required", "true"));
    };
    this.addEventListener("click", this._boundHandlers.selfClick);

    this._boundHandlers.triggerClick = (event) => {
      event.stopImmediatePropagation();
      if (!this.hasAttribute("ean-open")) {
        this.setAttribute("ean-open", "true");
        eanInputs.forEach((input) => input.setAttribute("required", "true"));
      } else {
        this.removeAttribute("ean-open");
        eanInputs.forEach((input) => input.removeAttribute("required"));
      }
    };
    eanTrigger?.addEventListener("click", this._boundHandlers.triggerClick);

    const localEan = localStorage.getItem("ean-attribute");
    if (localEan) {
      eanInput.value = localEan;
      const localReq = localStorage.getItem("req-attribute");
      if (localReq) {
        requisitionNumberInput.value = localReq;
      }
      this.setAttribute("ean-open", "true");
    }

    this._boundHandlers.syncCartAttributes = () => {
      const eanAttributeInput = cartForm.querySelector("#ean-attribute");
      const reqAttributeInput = cartForm.querySelector("#req-attribute");

      if (eanAttributeInput) {
        eanAttributeInput.value = eanInput.value;
        reqAttributeInput.value = requisitionNumberInput.value;
        localStorage.setItem("ean-attribute", eanInput.value);
        localStorage.setItem("req-attribute", requisitionNumberInput.value);
        return;
      }

      const eanAttribute = document.createElement("input");
      eanAttribute.type = "hidden";
      eanAttribute.id = "ean-attribute";
      eanAttribute.name = "attributes[_ean-number]";
      eanAttribute.value = eanInput.value;
      localStorage.setItem("ean-attribute", eanInput.value);

      const reqAttribute = document.createElement("input");
      reqAttribute.type = "hidden";
      reqAttribute.id = "req-attribute";
      reqAttribute.name = "attributes[_requisition-number]";
      reqAttribute.value = requisitionNumberInput.value;
      localStorage.setItem("req-attribute", requisitionNumberInput.value);

      cartForm.appendChild(eanAttribute);
      cartForm.appendChild(reqAttribute);
    };

    this._boundHandlers.eanChange = () => {
      if (eanInput.value) {
        requisitionNumberInput.setAttribute("required", "true");
      } else {
        requisitionNumberInput.removeAttribute("required");
      }
      this._boundHandlers.syncCartAttributes();
    };
    eanInput.addEventListener("change", this._boundHandlers.eanChange);
    eanInput.addEventListener("input", this._boundHandlers.syncCartAttributes);
    requisitionNumberInput.addEventListener("input", this._boundHandlers.syncCartAttributes);

    if (eanInput.value || requisitionNumberInput.value) {
      this._boundHandlers.syncCartAttributes();
    }

    this._boundHandlers.formSubmit = () => {
      if (
        (eanInput.value && eanInput.value.length !== 13) ||
        (eanInput.value && !requisitionNumberInput.value)
      ) {
        this.setAttribute("ean-open", "true");
      }
      this._boundHandlers.syncCartAttributes();
    };

    const cartLink = cartForm.querySelector('a[href="/cart"]');
    cartForm.addEventListener("submit", this._boundHandlers.formSubmit, { capture: true });
    cartLink?.addEventListener("click", this._boundHandlers.syncCartAttributes, { capture: true });
    this._cartLink = cartLink;
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._boundHandlers.selfClick);
    this._eanTrigger?.removeEventListener("click", this._boundHandlers.triggerClick);
    this._eanInput?.removeEventListener("change", this._boundHandlers.eanChange);
    this._eanInput?.removeEventListener("input", this._boundHandlers.syncCartAttributes);
    this._requisitionNumberInput?.removeEventListener("input", this._boundHandlers.syncCartAttributes);
    this._cartForm?.removeEventListener("submit", this._boundHandlers.formSubmit, { capture: true });
    this._cartLink?.removeEventListener("click", this._boundHandlers.syncCartAttributes, { capture: true });
    this._boundHandlers = {};
  }
}

customElements.define("ean-form", EanForm);
